(() => {
  const sticky = document.querySelector('.section-product-page .sticky-cta[data-bt-sticky-early]');
  const product = sticky?.closest('.section-product-page');
  const grid = product?.querySelector('.product.grid');
  const priceBlock = grid?.querySelector('.product__price');
  const primaryButton = grid?.querySelector('product-form .product-form__submit');

  if (!sticky || !grid || !primaryButton) return;

  let frame = 0;
  const privacyBannerIsVisible = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner) return false;

    const style = window.getComputedStyle(banner);
    const bounds = banner.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && bounds.width > 0 && bounds.height > 0;
  };

  const update = () => {
    frame = 0;

    if (!window.matchMedia('(max-width: 749.98px)').matches) {
      sticky.classList.remove('bt-sticky-cta--foreground');
      sticky.removeAttribute('inert');
      sticky.removeAttribute('aria-hidden');
      return;
    }

    const stickyTop = sticky.getBoundingClientRect().top;
    const gridBounds = grid.getBoundingClientRect();
    const buttonBounds = primaryButton.getBoundingClientRect();
    const priceBounds = priceBlock?.getBoundingClientRect();
    const headerBottom = Math.max(0, document.querySelector('.bt-site-header')?.getBoundingClientRect().bottom || 0);
    const usableBottom = stickyTop;
    const withinProduct = gridBounds.top < usableBottom && gridBounds.bottom > usableBottom;
    const primaryActionPassed = buttonBounds.bottom <= headerBottom;
    const primaryActionVisible = buttonBounds.top >= headerBottom && buttonBounds.bottom <= usableBottom;
    const priceCleared = priceBounds && priceBounds.bottom <= usableBottom - 12;
    // Keep the title and complete price block clear. Offer the sticky action
    // once the price leaves its safe area, and yield while the real button is
    // fully visible between the header and the sticky bar.
    const show = !privacyBannerIsVisible() && withinProduct && (primaryActionPassed || (priceCleared && !primaryActionVisible));

    sticky.classList.toggle('bt-sticky-cta--foreground', show);
    sticky.toggleAttribute('inert', !show);
    sticky.setAttribute('aria-hidden', String(!show));
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(grid);

  document.addEventListener('visitorConsentCollected', schedule);

  if (typeof window.MutationObserver === 'function') {
    const privacyBanner = document.querySelector('#shopify-pc__banner');
    if (privacyBanner) {
      const privacyBannerObserver = new window.MutationObserver(schedule);
      privacyBannerObserver.observe(privacyBanner, { attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
      window.addEventListener('pagehide', () => privacyBannerObserver.disconnect(), { once: true });
    }
  }

  schedule();
})();
